export const listaTiposIngresosIntegrales = [
    {nombre:'Recibo general',title:'Seleccionar Recibo General',id:'tipo-rg'},
    {nombre:'Resumen Fondos',title:'Seleccionar Resumen Fondos',id:'tipo-r-ru'},
    {nombre:'Resumen Fondos distribuido',title:'Seleccionar Resumen Fondos distribuido',id:'tipo-r-fd'},
    {nombre:'Resumen Forma de pago',title:'Seleccionar Resumen Forma de pago',id:'tipo-r-fp'},
    //{nombre:'Resumen Geográfico',title:'Seleccionar Resumen Geográfico',id:'tipo-r-geo'},
    {nombre:'Resumen Geográfico (por partido)',title:'Seleccionar Resumen Geográfico (por partido)',id:'tipo-r-geopa'},
    {nombre:'Resumen Geográfico Plano',title:'Seleccionar Resumen Geográfico plano',id:'tipo-r-geoplano'}
]



